import { HttpService } from "./http.service";

const basePath = "/Locale";
const request = HttpService.handleRequest();

export const LocaleService = {
  getAll,
  getAllCountries,
  getAllStates,
  getAllCities,
  getAllStatesbyLocale
};

async function getAll() {
  return request.get(basePath);
}

async function getAllCountries() {
  return request.get(
    `${basePath}/GetAllCountries/`
  );
}

async function getAllStates(countryId) {
  return request.get(
    `${basePath}/GetAllStates/${countryId}`
  );
}

async function getAllStatesbyLocale() {
  return request.get(
    `${basePath}/GetAllStatesByLocale/`
  );
}

async function getAllCities(cityId) {
  return request.get(
    `${basePath}/GetAllCities/${cityId}`
  );
}

export default LocaleService;